import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';

import NoSearchResults from './NoSearchResults.svg';

interface Props {
    show: boolean;
    handleClearSearch: () => void;
}

const Container = styled.div`
    border-radius: 0.7rem 0.7rem 0 0;
    margin: 0 auto;
    width: 500px;
    height: 400px;
`;

const ImageContainer = styled.img`
    margin-right: auto;
    margin-left: auto;
    display: flex;
`;

const Header = styled.div`
    font-weight: 700;
    font-size: 50px;
    text-align: center;
`;

const SubHeader = styled.div`
    font-weight: 500;
    text-align: center;
    font-size: 15px;
`;

const buttonSx = () => ({
    color: 'black',
    borderColor: 'black',
    display: 'flex',
    margin: 'auto',
    top: '20px',
    fontSize: '12px',
    padding: '5px 30px',
    '&:hover': {
        borderColor: 'black',
    },
});

export default function ({ show, handleClearSearch }: Props) {
    if (!show) return null;

    return (
        <Container>
            <ImageContainer src={NoSearchResults} alt="No Results" />
            <Header>No results found</Header>
            <SubHeader>Try adjusting your search to find what you’re looking for</SubHeader>
            <Button onClick={handleClearSearch} startIcon={<CloseIcon />} variant="outlined" sx={buttonSx}>
                CLEAR SEARCH
            </Button>
        </Container>
    );
}
